import { CloseCircleOutlined, LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Checkbox, Spin } from 'antd';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { marketValue } from '../../utils/api';

const CompareSalvage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [compareCars, setCompareCars] = useState([]);
    const [checkGenerate, setCheckedGenerate] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        if (location?.state?.CompareCars) {
            if (location?.state?.CompareCars.length === 4) {
                let data = location?.state?.CompareCars
                localStorage.setItem("compareSalvage", JSON.stringify(data));
                setCompareCars(data);
            } else {
                let data = [...location?.state?.CompareCars, { emptyData: true }];
                setCompareCars(data);
            }
        }
    }, [location]);

    useEffect(() => {
        if (checkGenerate.length) {
            setIsDisabled(false);
        } else {
            setIsDisabled(true)
        }
    }, [checkGenerate])

    const handleRemove = (id) => {
        const filtered = compareCars.filter((item) => {
            return id !== item?.vin
        })
        setCompareCars(filtered);
        let filterGenerate = filtered.filter((item) => {
            return checkGenerate.includes(item?.vin)
        }).map((item) => item?.vin)
        setCheckedGenerate(filterGenerate);
        let filterEmptyData = filtered.filter((item) => {
            return !item.emptyData
        })
        localStorage.setItem("compareSalvage", JSON.stringify(filterEmptyData))
        if (!filtered[filtered.length - 1].emptyData) {
            setCompareCars([...filtered, { emptyData: true }]);
        } else {
            if (filtered.length === 2) {
                navigate("/find_salvageCar", {
                    state: { filterInput: location?.state?.filters, formInputValues: location?.state?.inputFormValues },
                });
            }
        }
    }

    const handleCheckChange = (e, car) => {
        let res = car?.vin
        if (e.target.checked) {
            setCheckedGenerate([...checkGenerate, res]);
        } else {
            let filtered = checkGenerate.filter((item) => {
                return item !== res
            })
            setCheckedGenerate(filtered)
        }
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    // const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const handleAddToReport = async () => {
        let selectedCars = compareCars.filter((item) => checkGenerate.includes(item?.vin));
    
        try {
            setLoading(true);
            // const result = [];

            // for (const item of selectedCars) {
            //     const vinData = await marketValue(item.vin);
            //     result.push({ marketValue: vinData.data.data, vin: vinData.vin });

            //     // Add a delay of 1 second (1000ms) between each API call
            //     await delay(500);
            // }

            const updatedCars = selectedCars.map((item) => {
                if (item.bid === null) {
                    return {
                        ...item, bid: "There was no auction for this car in the last 6 months"
                    }

                }
                return item;
            });

            localStorage.setItem("salvageCars", JSON.stringify(updatedCars));
            navigate("/generatePage");
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Spin
                spinning={loading}
                indicator={
                    <LoadingOutlined
                        style={{
                            fontSize: 48,
                            color: 'black',
                        }}
                        spin
                    />
                }
            >
                <div className='p-4 md:p-12'>
                    <div className='flex justify-between md:flex-row flex-col flex-wrap gap-16 xl:gap-0'>
                        {compareCars.map((res, i) => {
                            console.log('resqqqqqqqqqqq', res)
                            return <>
                                <div className="w-full sm:w-[-webkit-fill-available] md:w-[45%] xl:w-[22%]" >

                                    {!compareCars[i].emptyData ? <div style={{ height: "338px" }}>
                                        <div
                                            style={{
                                                boxShadow: '1px 0px 12px 2px #57575733',
                                                border: '0.5px solid #7D7D7D',
                                                height: "100%"
                                            }}
                                        >
                                            {
                                                <div className='slider-container min-h-[222px] findCardSlider relative'>
                                                    {res?.images[0] && JSON.parse(res?.images[0]) && <>
                                                        <Slider {...settings}>
                                                            {JSON.parse(res?.images[0])
                                                                ?.filter((_, i) => i < 6)
                                                                ?.map((url) => (
                                                                    <div key={url}>
                                                                        <img src={url} alt='' className='w-full object-fill' />
                                                                    </div>
                                                                ))}
                                                        </Slider>
                                                        <div className='absolute top-[-12px] bg-white right-[-12px] rounded-[50%] flex items-center cursor-pointer'>
                                                            <CloseCircleOutlined className='text-[30px]' onClick={() => handleRemove(res?.vin)} />
                                                        </div>
                                                    </>}
                                                </div>
                                            }
                                            {
                                                res && <>
                                                    <div className='flex flex-col justify-between h-[114px]'>
                                                        <div className='p-3'>
                                                            <h2 className='font-semibold'>
                                                                {res.title}
                                                            </h2>
                                                        </div>
                                                        <div className='p-3 pt-0 text-[20px]'>
                                                            <h2 className='font-normal'>
                                                                <b>Price: ${res?.buy_now_price ? res?.buy_now_price : "not available"}</b></h2>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div> : <div className='flex justify-center items-center'>
                                        <div className='p-3 pt-[64px]'>
                                            <div className='text-[60px] flex justify-center'>
                                                <PlusCircleOutlined className='cursor-pointer' onClick={() => navigate('/find_salvageCar', {
                                                    state: { filterInput: location?.state?.filters, formInputValues: location?.state?.inputFormValues },
                                                })} />
                                            </div>
                                            <h2 className='font-semibold mt-4'>
                                                Add More car to compare
                                            </h2>
                                        </div>
                                    </div>}

                                    {!compareCars[i].emptyData &&
                                        <>
                                            <div className='border-t mt-16 border-b'>
                                            </div>
                                            <div >
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Brand
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.manufacturer ? res?.manufacturer : "-"}</b></h2>
                                                </div>
                                            </div>
                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Model
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.model ? res?.model : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Engine
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.eng_name ? res?.eng_name.split(",")[0].split(" ")[0] : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Horsepower
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.eng_name?.trim().toLowerCase().endsWith("hp") ? res?.eng_name.split(",")[res?.eng_name.split(",").length - 1] : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Odometer
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.odometer_mi ? res?.odometer_mi : "-"} Miles</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Transmission
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.transmission ? res?.transmission : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Cylinders
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.cylinders ? res?.cylinders : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Driven Wheels
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.drive_wheel ? res?.drive_wheel : "-"}</b></h2>
                                                </div>
                                            </div>
                                            <Checkbox checked={checkGenerate.includes(res?.vin)} className='custom-checkbox my-4' onChange={(e) => handleCheckChange(e, res)}>Add To Condition Report</Checkbox>
                                        </>
                                    }
                                </div>
                            </>
                        })}
                    </div>

                    <div className='flex justify-center mt-12'>
                        <button className={`${isDisabled ? "bg-[#d7dbde]" : "darkBlue"} px-[52px] py-[25px] text-white text-lg mb-[31px]`} disabled={isDisabled} onClick={handleAddToReport} >
                            Add to Condition Report
                        </button>
                    </div>
                </div>
            </Spin>
        </>
    )
}

export default CompareSalvage
